// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__MhU4K","card":"Card_card__hhtIP","title":"Card_title__Fc8OW"};